<section class="h-100 position-relative">
    <!--<sen-app-set-margin></sen-app-set-margin>-->
    <mat-tab-group animationDuration="0ms" class="sen-fs10 px-3 sen-submenu-color">
        <mat-tab [label]="translate.getLng('CUST_ADDR')">
            <!-- <ng-template matTabContent> -->
            <sen-app-psd-customer-address (address)="apiOptions.owner = $event" [data]="apiOptions.owner">
            </sen-app-psd-customer-address>
            <!-- </ng-template> -->
        </mat-tab>
        <mat-tab [label]="translate.getLng('EDIT_ADDR')">
            <!-- <ng-template matTabContent> -->
            <sen-app-psd-editor-address (address)="apiOptions.editor = $event" [data]="apiOptions.editor">
            </sen-app-psd-editor-address>
            <!-- </ng-template> -->
        </mat-tab>
        <mat-tab [label]="translate.getLng('SYS_ISSUER')">
            <!-- <ng-template matTabContent> -->
            <sen-app-psd-installer-address (address)="apiOptions.installer = $event" [data]="apiOptions.installer">
            </sen-app-psd-installer-address>
            <!-- </ng-template> -->
        </mat-tab>
        <mat-tab [label]="translate.getLng('PSD_OPTIONS')">
            <!-- <ng-template matTabContent> -->
            <sen-app-psd-options (options)="setOptions($event)" (blob)="setImageBlob($event)"></sen-app-psd-options>
            <!-- </ng-template> -->
        </mat-tab>
        <!--
        <mat-tab [label]="translate.getLng('PSD_PUD')">
            <ng-template matTabContent>
                <sen-app-psd-public-utility-data></sen-app-psd-public-utility-data>
            </ng-template>
        </mat-tab>-->
    </mat-tab-group>
    <button mat-raised-button (click)="printPDF()" color="primary" class="my-2 mx-3 py-2 sen-bottom-button">
        <mat-icon>picture_as_pdf</mat-icon> {{translate.getLng('PDF_PRINT')}}
    </button>
</section>